import { render, staticRenderFns } from "./ScreenConvenio.vue?vue&type=template&id=5c5169b6"
import script from "./ScreenConvenio.vue?vue&type=script&lang=js"
export * from "./ScreenConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports